import {useMemo, useEffect, useState} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {CustomRow} from '../table/columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {usersColumns} from './columns/_columns'
import {User} from '../core/_models'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {UsersListPagination} from '../components/pagination/UsersListPagination'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import api from '../../../../../utils/Api'
import Pagination from '../../../../../components/Pagination'
import moment from 'moment'
import {numberFormat} from '../../../../../utils/Functions'
import {useLocation, useParams} from 'react-router-dom'
import {IncomeDocumentStateTypes, IncomeDocumentTypes} from '../../../../../constants/Common'

const UsersTable = ({s = '', params = {}}) => {
  const [data, setData] = useState([])
  const { state } = useParams()
  const [pagination, setPagination] = useState({total: 1, last_page: 1, current_page: 1})
  const [loading, setLoading] = useState(false)
  const {total, last_page, current_page} = pagination
  const location = useLocation()
  const isInExpensePurchaseOrderAssetPage = location.pathname.includes("expense-purchase-asset-order");

  const fetch = (page = 1, _params = {})=>{
    api.request('account/income-document', ({data, meta}) => {
      setData(data)
      setPagination(meta)
    }, {
      s,
      type: isInExpensePurchaseOrderAssetPage ? IncomeDocumentTypes.EXPENSE_PURCHASE_ASSET_ORDER : IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER,
      state: IncomeDocumentStateTypes.COMPLETELY,
      ...params,
      ..._params,
      page
    })
  }

  const columns = useMemo(()=>usersColumns(() => fetch()), [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  useEffect(()=>{
    fetch()
  }, [s, params])

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table table-striped align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: any) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: any, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={8}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {loading && <UsersListLoading />}
      <div className="float-end py-5">
      <Pagination
      goToPage={(p)=>fetch(p)}
      lastPage={last_page}
       page={current_page} />
      {/*<UsersListPagination />*/}
      </div>
    </KTCardBody>
  )
}

export {UsersTable}
